<template>
    <div class="w-full h-full relative overflow-hidden">
        <div class="w-full h-full">
            <MapLineView ref="mapEditor" :linePoint="linePoint" :lineMarker="lineMarker" @check="checkMarker">
                <template #info>
                    <div class="line-info" @click="detailOpen">{{ detailInfo.name }}</div>
                </template>
            </MapLineView>
        </div>
        <div class="line-card" :style="{ left: detailShow ? '0' : '-340px' }">
            <LineDetailCard :info="detailInfo" :typeOptions="typeOptions" @closeBefore="detailClose" />
        </div>
        <div class="point-card" :style="{ right: markerDetailShow ? '20px' : '-340px' }">
            <LinePointDetailCard :info="markerDetailInfo" @closeBefore="markerDetailClose" />
        </div>
    </div>
</template>
<script>
	import MapLineView from '@/components/MapLineView.vue';
	import LineDetailCard from './components/LineDetailCard.vue';
	import LinePointDetailCard from './components/LinePointDetailCard.vue';
	import { getJson } from "@/utils/axios.js"
    export default{
		components: { MapLineView, LineDetailCard, LinePointDetailCard },
        data(){
            return{
                detailShow: true,
                markerDetailShow: false,
                detailInfo: {},
                markerDetailInfo: {},
                id: this.$route.query.id,
                typeOptions: [],
                linePoint:[],
                lineMarker: []
            }
        },
        computed: {
			isMobile() {
				return window.innerWidth < 768 // 根据实际需求定义断点
			}
		},
        methods: {
            checkVRView(){
                window.open(`${window.location.origin}/view?id=${this.detailInfo.id}`)
            },
            checkMarker(item){
                this.markerDetailInfo = item
                this.markerDetailShow = true
            },
            markerDetailClose(){
                this.markerDetailShow = false
            },
            detailOpen(){
                this.detailShow = true
            },
            detailClose(){
                this.detailShow = false
            },
            getDicOptions(){
				getJson('/dicContent/list', { dicKey: 'walk_line_type' }, (res) => {
					this.typeOptions = res.data || []
				})
			},
            getLineContent(){
                getJson('/linePoint/list', {
					lineId: this.id,
				}, (res) => {
					const { data } = res
                    const lineMarker = data || []
                    this.lineMarker = lineMarker.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            location: item.location ? JSON.parse(item.location) : null,
                            pictureList: item.picture ? item.picture.split(',') : [],
                            vrinfo: item.vrinfo,
                            address: item.address,
                            remark: item.remark
                        }
                    });
                    this.getDetail()
				})
            },
			getDetail(){
				getJson('/line/info', {
					id: this.id,
				}, (res) => {
					const { data } = res
                    this.detailInfo = data || {}
                    this.detailInfo.tags = this.detailInfo.tags ? this.detailInfo.tags.split(',') :[]
                    this.detailInfo.pictureList = this.detailInfo.picture ? this.detailInfo.picture.split(',') : []
                    this.linePoint = JSON.parse(this.detailInfo.linePoints)
				})
			},
        },
        created(){
            this.getDicOptions()
            this.getLineContent()
        }
    }
</script>
<style scoped lang="scss">
    .line-info{
        cursor: pointer;
        border-radius: 5px;
        background-color: rgba($color: #FFF, $alpha: 0.95);
        padding: 4px 10px;
        font-size: 14px;
        color: #409EFF;
        transition: 300ms;
    }
    .line-info:hover{
        color: #4A51E4;
    }
    .line-card{
        position: absolute;
        top: 00px;
        transition: 300ms;
        z-index: 2001;
    }
    .point-card{
        position: absolute;
        bottom: 40px;
        transition: 300ms;
        z-index: 2001;
    }
</style>